<template>
<div>
  <b-media>
    <b-media-body>
      <b-form-fieldset>
        <div v-if="alert" :class="['alert', `alert-${alert.color}`]" role="alert">{{ alert.msg }}</div>
        <legend class="border-bottom">
          <b-col>
            <b-row>
              <b-col>
                <b-row v-if="user && toggleEditName">
                  <b-form-input placeholder="First Name" class="col-5" v-model="user.first_name"/>
                  <b-form-input placeholder="Last Name" class="col-5" v-model="user.last_name"/>
                </b-row>
                <h2 v-else-if="user">
                  {{ user.first_name || "[ First Name ]" }}
                  {{ user.last_name  || "[ Last Name ]" }}
                </h2>
              </b-col>
              <v-btn v-if="user && toggleEditName" class="mx-n5 btn btn-outline-primary" @click="submitChanges()">Save</v-btn>
              <v-btn v-else text class="mx-n5" @click="toggleEditName = !toggleEditName"><v-icon>mdi-pencil</v-icon></v-btn>
            </b-row>
            <p class="text-secondary">{{ user.email }}</p>
          </b-col>
        </legend>
        <small>Make sure to press update to send any changes</small>
      </b-form-fieldset>
    </b-media-body>
  </b-media>

  <div class="mb-3">

    <!-- Phone Number -->
    <div class="row p-2">
      <label class="col-md-5 control-label" for="selectbasic">Phone Number</label>
      <b-form-input v-model="user.phone" placeholder="Enter your Phone Number" size="sm" class="col-md mx-5"></b-form-input>
    </div>

    <!-- Phone Provider -->
    <div class="row p-2">
      <label class="col-md-5 control-label" for="selectbasic">Phone Provider</label>
      <b-form-select v-model="ProviderSelected" size="sm" class="col-md mx-5">
        <b-form-select-option v-for="(val, name) in ProviderOptions" :key="name" :value="val">{{ name }}</b-form-select-option>
      </b-form-select>
    </div>      

    <!-- Notification Percents -->
    <div class="row p-2">
      <div class="col-md-5 control-label">
        <label class="mb-0">Notification Setting</label>
        <br/>
        <small>At what level would you like to be notified?</small>
      </div>
      <div class="col-md mx-5">
        <!-- <small class="text-muted">high:</small> -->
        <!-- <b-form-select v-model="HighSelected" size="sm" class=""> -->
          <!-- <b-form-select-option v-for="(val, name) in HighOptions" :key="name" :value="val">{{ name }}</b-form-select-option> -->
        <!-- </b-form-select> -->
        <!-- <small class="text-muted">low:</small> -->
        <div>Salt Level:</div>
        <b-form-select v-model="LowSelected" size="sm" class="">
          <b-form-select-option v-for="(val, name) in LowOptions" :key="name" :value="val">{{ name }}</b-form-select-option>
        </b-form-select>
      </div>
    </div>

    <!-- Tank Depth -->
    <div class="row p-2">
      <label class="col-md-5 control-label" for="selectbasic">Tank Depth</label>
      <div class="col-md mx-4">
        <strong>( {{ parseInt(depth.in) }} ) in</strong>
        <b-form-input type="range" v-model="depth.in" step="1" size="sm" :min="depth.selected === 'in' ? 20 : 50" :max="depth.selected === 'in' ? 60 : 150" class=""></b-form-input>
      </div>
    </div>  

    <!-- Sensor Key -->
    <div id="sensor-key" class="row p-2">
      <label class="col-md-5 control-label" for="selectbasic">Sensor Key</label>
      <b-form-input v-model="sensor" placeholder="Enter your Sensor Key" size="sm" class="col-md mx-5"></b-form-input>
      <small v-if="sensor === '' || !sensor" class="col-12 pull-right">Your Sensor Key is Provided on the Device, watch the <a href="https://ezsalt.xyz/how-to-install">setup video</a></small>
    </div>

    <hr/>

    <!-- Enable Salt Delivery -->
    <div class="row p-2 my-3">
      <label class="col-md-5 control-label" for="selectbasic">Enable Salt Delivery</label>
      <b-form-select v-model="DeliverySelected" size="sm" class="col-md mx-auto w-25">
        <b-form-select-option v-for="(val, name) in BooleanOptions" :key="name" :value="val">{{ name }}</b-form-select-option>
      </b-form-select>
    </div> 
    
    <!-- Address -->
    <!-- 
      street_address: "",
      city: "",
      state: "",
      zipcode: ""
    -->
    <div v-show="DeliverySelected" class="border">
      <div class="row p-2">
        <label class="col-md-5 control-label" for="selectbasic">Address</label>
        <b-form-input v-model="user.street_address" placeholder="" size="sm" class="col-md mx-5"></b-form-input>
      </div>
      <div class="row p-2">
        <div class="col-6">
          <label class="col-md-5 control-label" for="inputCity">City</label>
          <b-form-input v-model="user.city" placeholder="" size="sm" class="col-md-5 mx-auto"></b-form-input>
        </div>
        <div class="col-3">
          <label class="col-md-5 control-label" for="inputState">State</label>
          <b-form-input v-model="user.state" placeholder="" size="sm" class="col-md-5 mx-auto"></b-form-input>
        </div>
        <div class="col-3">
          <label class="col-md-5 control-label" for="inputZip">Zip</label>
          <b-form-input v-model="user.zipcode" placeholder="" size="sm" class="col-md-5 mx-auto"></b-form-input>
        </div>
      </div>
    </div>

    <!-- Stripe -->
    <!-- <div class="row p-2 my-5">
      <div class="mx-auto control-label">Activate your Account - <router-link :to="{ name: 'Card-Info' }" >Here</router-link></div>
      <small class="col-12">We use <a href="https://www.stripe.com" target="_blank">Stripe</a> for all Payment needs</small>
    </div> -->

  </div>

  <!-- Update Button -->
  <div class="container my-3">
    <div class="row">
      <button class="col m-2 card-1 btn btn-outline-primary" @click="submitChanges()">Update</button>
      <button class="col m-2 card-1 btn btn-outline-primary" @click="cancel()">Cancel</button>
    </div>
  </div>
</div>
</template>

<script>
import { db, auth } from '../firebase'
import myDB from '../services/dbservice'
import store from "../store";
import { mapGetters } from "vuex";

export default {
  name: "Profile",
  data() {
    return {

      toggleEditName: false,
      alert: null,

      user: {
        email: "Loading...",
        phone: "Loading...",
        street_address: "",
        city: "",
        state: "",
        zipcode: ""
      },

      sensor: null,

      displayName: null,
      email: null,

      depth: {
        cm: null,
        in: null,
        selected: 'in'
      },

      DeliverySelected: null,      
      BooleanOptions: {
        "On": true,
        "Off": false,
      },
      ProviderSelected: null,
      ProviderOptions: [],

      HighSelected: null,
      HighOptions: [
        { value: null, text: 'Not Yet implemented', disabled: true },
        { value: null, text: 'Please select a High Option', disabled: true },
      ],
      LowSelected: null,
      LowOptions: []

    }
  },
  watch: {
    depth: {
      handler: function (val, oldVal) {

        val.in = parseFloat(parseFloat(val.in).toFixed(9))

        if ( val.selected === oldVal.selected ){
          if ( val.in !== oldVal.in ){
            // cm changed
            val.in = val.cm / 2.54
          } else {
            // in changed
            val.cm = val.in * 2.54
          }
        } else {
          // selected changed
          console.log("The Depth Type was changed")
        }
        return val
      },
      deep: true
    },
    DeliverySelected: {
      handler: async function (val, oldVal) {
        if (oldVal !== null) {
          if (val) {
            // Turning On Salt Delivery
            let zip = prompt("What is your zipcode, to check it you're eligible for Salt Delivery")
            let exists = this.zipcodes.includes(parseInt(zip));
            this.DeliverySelected = exists;
            if (!exists) {
              alert(`( ${zip} ) does not have Salt Delivery`)
            }
          } else {
            // Turning Off Salt Delivery
            return val;
          }
        }
      },
      deep: true
    }
  },
  computed: mapGetters(["zipcodes"]),
  methods: {
    submitChanges() {
      myDB.updateProfile({
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        depth: parseInt(this.depth.cm), 
        phone: this.user.phone, 
        phone_provider: this.ProviderSelected,
        send_percent: { high: this.HighSelected, low: this.LowSelected },
        sensor: this.sensor,
        delivery_enabled: this.DeliverySelected
      }).then(() => {
        this.toggleEditName = false
        this.alert = {
            "msg": "Success, your changes were successfully sent",
            "color": "success"
          }
        setTimeout(() => this.alert = null , 9600)
      });
    },
    cancel() {
      this.getData();
      this.$router.push('/')
    },
    sort_object(obj) {
      let items = Object.keys(obj).map((key) => [key, obj[key]])
      items.sort((a, b) => a[1] - b[1]);

      let sorted_obj={}
      items.forEach( (k) => sorted_obj[k[0]] = k[1] )

      return sorted_obj
    },
    getData() {
      auth.onAuthStateChanged(user =>  {
        if (user) {
          // User is signed in.

          this.displayName = user.displayName
          this.email = user.email
          
          // ProviderOptions
          db.doc('variables/Admin').get()
          .then(doc => {
            let data = doc.data()
            this.ProviderOptions = data.ProviderOptions 
            this.HighOptions = data.HighOptions
            this.LowOptions = this.sort_object(data.LowOptions)
          }).then(async () => {
            await myDB.getUserData(user.uid).then(data => {
              this.user = data
              this.sensor = data.sensor
              this.depth.cm = data.depth
              this.DeliverySelected = data.delivery_enabled
              this.ProviderSelected = data.phone_provider
              this.HighSelected = data.send_percent.high
              this.LowSelected = data.send_percent.low
            });
          }).then(() => {
            this.alerts()
          });

        } else {
          // No user is signed in.
        }
      });    
    },
    alerts() {
      if ( ! this.sensor || this.sensor === "") {
        this.alert = {
          "msg": "Please add your Sensor id to your new Account",
          "color": "primary"
        }
      }
      setTimeout(() => this.alert = null , 9600)
    },
  },

  created() {
    this.getData()
  }
}
</script>

<style>

</style>